import { CertificateEmphasisTableDescription } from "../types";

export const defaultTableDescriptionData: CertificateEmphasisTableDescription =
  {
    title: "Ways to take this course",
    subtitle:
      "Enroll in an edX course through an audit or certificate track. Audit at no cost and receive limited course materials. If you'd like to earn elevate your learning with assignments and a certificate, a fee is required.",
    highlightedText: "Unlimited access to the course",
  };
